export const BUTTON_DELAY = 500;
export const BUTTON_INTERVAL = 135;
